import { theme } from '@bloomays-lib/ui.shared';
import { TalentBoardJobFunnelPhase } from '@bloomays-lib/types.shared';

export const getPhaseColor = (phase: TalentBoardJobFunnelPhase): string => {
  switch (phase) {
    case TalentBoardJobFunnelPhase.Qualification:
      return theme.palette.red[40];
    case TalentBoardJobFunnelPhase.Positionnement:
      return theme.palette.blue[40];
    case TalentBoardJobFunnelPhase.ITWClient:
      return theme.palette.green[40];
    case TalentBoardJobFunnelPhase.NotValidated:
      return theme.palette.neutral[20];
  }
};
